export const emojiShortnameRegexp = '(:[^\\s:]+(?:::skin-tone-[1-6])?:)'
export const emailEmojiAttributeName = 'emailEmoji' as const
export const htmlEmojiDefaultUrl = 'https://downloads.textmagic.com/email_assets/images/empty-filler.gif' as const
export const emailEmojiImgClasses = 'tm-emoji tm-email-emoji-type-image tm-email-emoji-set-apple' as const
